import styled from 'styled-components';

import { colors, cssBreakpoints, transition } from 'theme/theme';

export const TabsContainer = styled.div`
  overflow: hidden;
  position: relative;
`;

export const TabsUl = styled.ul<{
  $layout: 'vertical-on-desktop' | 'horizontal';
  $variant: 'background' | 'marker' | 'compact-marker';
}>`
  display: ${(props) =>
    props.$layout === 'vertical-on-desktop' ? 'inline-flex' : 'flex'};
  flex-direction: ${(props) =>
    props.$layout === 'vertical-on-desktop' ? 'column' : 'row'};
  overflow: auto;
  gap: ${(props) => (props.$variant === 'background' ? 18 : 20)}px;
  padding: 0;
  margin: 0;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: flex;
    flex-direction: row;
  }
`;

export const TabsMarker = styled.div`
  position: absolute;
  overflow: hidden;
  height: 2px;
  transform: translateY(-100%);
  background: ${colors.brandBlue};
  transition: ${transition};
  z-index: 2;
`;
